import React from 'react';
import useInView from '../hooks/useInView.js';

/**
 * Wrapper component that adds a subtle scroll-triggered animation.
 *
 * Content is ALWAYS visible — never hidden behind opacity:0.
 * The animation is purely decorative: a gentle slide/fade that fires once
 * when the element scrolls into view. If JavaScript hasn't run yet or the
 * observer hasn't fired, the user still sees all content normally.
 */
const AnimateOnScroll = ({
  animation = 'fade-in-up',
  delay = 0,
  threshold = 0.1,
  className = '',
  as: Tag = 'div',
  children,
  ...rest
}) => {
  const { ref, isInView } = useInView({ threshold });

  const animClass = isInView ? `animate-${animation}` : '';
  const style = isInView && delay > 0 ? { animationDelay: `${delay}ms` } : undefined;

  return (
    <Tag
      ref={ref}
      className={`${animClass} ${className}`}
      style={style}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default AnimateOnScroll;
